import {
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

import {
  MatAutocomplete,
  MatAutocompleteOrigin,
  MatAutocompleteTrigger,
  MatOption,
} from '@angular/material/autocomplete';

import { Trip } from '../../classes/trip';
import { TripBase } from '../../classes/trip-base';

import { DESKTOP_SUGGESTIONS } from '../../constants/suggestions.const';

import { ClickOutsideDirective } from '../../directives/click-outside.directive';

import { OVERLAY_PANEL_DATA } from '../../../core/services/overlay-panel';
import { OverlayPanelRef } from '../../../core/services/overlay-panel/overlay-panel-ref';

@Component({
  selector: 'app-locations-panel',
  imports: [
    AsyncPipe,
    MatAutocomplete,
    MatOption,
    MatAutocompleteTrigger,
    MatAutocompleteOrigin,
    ClickOutsideDirective,
  ],
  templateUrl: './locations-panel.component.html',
  styleUrl: './locations-panel.component.scss',
})
export class LocationsPanelComponent extends TripBase implements OnInit {
  public readonly suggestions = DESKTOP_SUGGESTIONS;
  public trip = inject<WritableSignal<Trip>>(OVERLAY_PANEL_DATA);

  @ViewChild('endInput') override readonly endInputRef: ElementRef;

  #ref: OverlayPanelRef = inject(OverlayPanelRef);

  ngOnInit(): void {
    this.setupStartInOptions();
    this.setupEndInOptions();
    this.defaultView = this.trip().isPlanningTripLocation;
  }

  closePanel(): void {
    this.#ref.close();
  }

  autoGoToNextField(): void {
    this.#ref.emitValue(true);
    this.#ref.close();
  }
}
